import { formatCurrency as externalFormatCurrency } from "~/common/utils/currencyFormatter";
import { strictIsNonNull } from "~/common/utils/reducers";

export function makeFormatCurrency(currency: string) {
  return (amount: number | undefined | null) => {
    return strictIsNonNull(amount) ? externalFormatCurrency(amount, currency) : "-";
  };
}
